import React, { useState, useEffect } from 'react';
import { MessageCircle, ArrowRightLeft, Video } from 'lucide-react';
import Communication from './Communication';
import ChangeRequests from './ChangeRequests';
import VideoCalls from './VideoCalls';

var TABS = [
  { id: 'messages', label: 'Messages', shortLabel: 'Messages', icon: MessageCircle },
  { id: 'requests', label: 'Change Requests', shortLabel: 'Requests', icon: ArrowRightLeft },
  { id: 'video', label: 'Video Calling', shortLabel: 'Video', icon: Video },
];

function CommunicationHub({ ws }) {
  var [tab, setTab] = useState('messages');

  // External actors (e.g., the incoming-call toast on Dashboard) can ask us to
  // switch to a specific tab via window event.
  useEffect(function () {
    var handler = function (e) {
      var next = e && e.detail;
      if (next && TABS.some(function (t) { return t.id === next; })) setTab(next);
    };
    window.addEventListener('set-comms-tab', handler);
    return function () { window.removeEventListener('set-comms-tab', handler); };
  }, []);

  // If the user accepted an incoming call before this page mounted, the room
  // is sitting in sessionStorage. Jump straight to the Video tab so VideoCalls
  // can pick it up.
  useEffect(function () {
    try {
      if (sessionStorage.getItem('parentum_pending_video_join')) {
        setTab('video');
      }
    } catch (e) { /* ignore */ }
  }, []);

  return (
    <div className="space-y-6" data-testid="communication-hub">
      <div className="flex gap-1 p-1 bg-white border border-[#DDE1EE] rounded-xl overflow-x-auto">
        {TABS.map(function (t) {
          var Icon = t.icon;
          return (
            <button key={t.id} onClick={function () { setTab(t.id); }}
              className={'flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all whitespace-nowrap flex-shrink-0 ' +
                (tab === t.id ? 'bg-gradient-to-r from-[#2D2560] to-[#5A4E9E] text-white' : 'text-[#3A3566] hover:bg-[#F6F7FC]')}
              data-testid={'comm-tab-' + t.id}>
              <Icon className="w-4 h-4" />
              <span className="hidden sm:inline">{t.label}</span>
              <span className="sm:hidden">{t.shortLabel}</span>
            </button>
          );
        })}
      </div>
      {tab === 'messages' && <Communication ws={ws} />}
      {tab === 'requests' && <ChangeRequests />}
      {tab === 'video' && <VideoCalls />}
    </div>
  );
}

export default CommunicationHub;
